import initialState from './../initialState';


// IMPORTANT: Note that with Redux, state should NEVER be changed.
// State is considered immutable. Instead,
// create a copy of the state passed and set new values on the copy.
// Note that I'm using Object.assign to create a copy of current state
// and update values on the copy.

let reducers = {
  LOGIN_SUCCESS : (state, payload) => {
    return [...state,  Object.assign({}, payload)];
  },
  LOGIN_FAILURE : (state, payload) => {
    return [...state, Object.assign({}, payload)];
  },
  LOGOUT_SUCCESS: () => {
    return [{authenticated: false}];
  }
};

export default function login(state = initialState.login, action) {
  let reducer = reducers[action.type];
  return (reducer ? reducer(state, action.login): state);
}



/** WEBPACK FOOTER **
 ** ./src/reducers/authentication/loginReducer.js
 **/